import React, { useContext } from 'react';
import styled from 'styled-components';

import { EmbedShowcaseContext } from '../context/useEmbedShowcase';
import { MOBILE_BREAKPOINT } from '../utils/constants';
import { getDomain } from '../utils/helpers';

type Props = {
  albumId: number;
  width?: string;
  height?: string;
  mobileHeight?: string;
  position?: 'static' | 'relative' | 'absolute' | 'sticky' | 'fixed';
  isOffsite?: boolean;
};

const StyledIframe = styled.iframe<{
  width: string;
  height: string;
  position: string;
  mobileHeight: string;
}>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  position: ${({ position }) => position};
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    height: ${({ mobileHeight }) => mobileHeight};
  }
`;

const Player = ({
  albumId,
  width = '100%',
  height = '100%',
  position = 'absolute',
  mobileHeight = '100%',
  isOffsite,
}: Props) => {
  const embedShowcaseData = useContext(EmbedShowcaseContext);

  return (
    <StyledIframe
      src={`${getDomain(isOffsite)}/showcase/${albumId}/embed${
        embedShowcaseData?.isShowcaseEmbeded
          ? `?referrer=${encodeURIComponent(document?.referrer)}`
          : ''
      }`}
      width={width}
      height={height}
      mobileHeight={mobileHeight}
      position={position}
    />
  );
};

export default Player;
